import React from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { UserCheck, ArrowLeft } from 'lucide-react'
import { Button } from '../ui/button'
import ContentEditorForm from '../shared/ContentEditorForm'

const AdminContentEditor = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const siteId     = searchParams.get('site')
  const clientId   = searchParams.get('clientId')
  const clientName = searchParams.get('clientName') || 'Client'

  const handleExit = () => navigate('/admin/sites')

  return (
    <div className="space-y-0">
      {/* Impersonation banner */}
      <div className="flex items-center justify-between px-6 py-2.5 bg-warning-50 dark:bg-warning-900/20 border-b border-warning-200 dark:border-warning-700 -mx-6 -mt-6 mb-6">
        <div className="flex items-center gap-2 text-sm text-warning-800 dark:text-warning-300">
          <UserCheck className="h-4 w-4 shrink-0" />
          <span>
            Editing on behalf of <span className="font-semibold">{clientName}</span>
            {' '}— changes save directly to their site.
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleExit}
          className="gap-1.5 text-warning-700 dark:text-warning-400 hover:bg-warning-100 dark:hover:bg-warning-900/30 shrink-0"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Exit to Admin
        </Button>
      </div>

      {siteId ? (
        <ContentEditorForm
          siteId={siteId}
          clientId={clientId}
          onBack={handleExit}
          showRequestChange={false}
        />
      ) : (
        <div className="flex flex-col items-center justify-center h-64 space-y-4">
          <p className="text-neutral-500 dark:text-neutral-400">No site selected.</p>
          <Button variant="outline" onClick={handleExit}>Back to Sites</Button>
        </div>
      )}
    </div>
  )
}

export default AdminContentEditor
